export function NoPage() {
  return (
    <div>
      <h1>Page not found</h1>
    </div>
  );
}
